import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Form, Input, Typography, Alert } from "antd";
import { CalendarOutlined, EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { useAppDispatch } from "@/store/hooks";
import { loginThunk } from "@/store/slices/authSlice";

const { Title, Text, Paragraph } = Typography;

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const isLoading = false
  const errorMsg = ""
  // const [isLoading, setIsLoading] = useState(false);
  // const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const resultAction = await dispatch(
      loginThunk({
        loginId: email,
        password,
      })
    );
    if (loginThunk.fulfilled.match(resultAction)) {
      navigate("/", { replace: true });
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        backgroundColor: "#F5F6F8",
      }}
    >
      <div style={{ width: "100%", maxWidth: 400 }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div
            style={{
              width: 48,
              height: 48,
              margin: "0 auto 16px",
              borderRadius: 12,
              backgroundColor: "#2563EB",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CalendarOutlined style={{ color: "#FFFFFF", fontSize: 20 }} />
          </div>

          <Paragraph
            style={{
              marginBottom: 0,
              fontSize: 14,
              fontWeight: 500,
              color: "#6B7280",
            }}
          >
            드레스 투어 관리
          </Paragraph>
        </div>

        <Card
          styles={{
            body: {
              padding: 32,
            },
          }}
          style={{
            borderRadius: 12,
            boxShadow: "0 4px 16px rgba(0,0,0,0.05)",
            border: "1px solid #F0F0F0",
          }}
        >
          <div style={{ marginBottom: 24 }}>
            <Title
              level={3}
              style={{
                marginBottom: 4,
                fontSize: 22,
                fontWeight: 600,
                color: "#111827",
              }}
            >
              로그인
            </Title>

            <Text
              style={{
                fontSize: 14,
                color: "#6B7280",
              }}
            >
              발급 받은 계정을 이용해서 로그인해주세요
            </Text>
          </div>

          <form onSubmit={handleSubmit}>
            {errorMsg && (
              <Form.Item>
                <Alert message={errorMsg} type="error" showIcon />
              </Form.Item>
            )}

            <Form.Item
              label={<span style={{ fontSize: 14, fontWeight: 500 }}>아이디</span>}
              style={{ marginBottom: 16 }}
            >
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="아이디 입력"
                size="large"
                styles={{
                  input: {
                    fontSize: 14,
                  },
                }}
              />
            </Form.Item>

            <Form.Item
              label={<span style={{ fontSize: 14, fontWeight: 500 }}>비밀번호</span>}
              style={{ marginBottom: 24 }}
            >
              <Input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                size="large"
                styles={{
                  input: {
                    fontSize: 14,
                  },
                }}
                suffix={
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      cursor: "pointer",
                      color: "#8C8C8C",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {showPassword ? <EyeInvisibleOutlined /> : <EyeTwoTone />}
                  </span>
                }
              />
            </Form.Item>

            <Button
              htmlType="submit"
              type="primary"
              loading={isLoading}
              block
              size="large"
              style={{
                height: 44,
                borderRadius: 8,
                backgroundColor: "#2563EB",
              }}
            >
              {isLoading ? "로그인 중..." : "로그인"}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}